<template>

<div style='display: inline-block; margin-right: 0.3rem;'>
    <span @click.self='showColorPicker' class="glyphicon glyphicon-pencil"/>
    <div @click.self='changeToSelected' :style='getBackgroundColorStyle()'>
    </div>
    <div class='small-top-padding' v-if='colorPickerVisible'>
        <photoshop :id='"ps" + renderingKey' v-model='currentColor' @ok="hideColorPicker" @cancel="doCancel"/>
    </div>
</div>

</template>

<script>

import { Photoshop } from 'vue-color'

export default {
    // https://stackoverflow.com/questions/40410332/vuejs-access-child-components-data-from-parent
    // https://stackoverflow.com/questions/45478035/start-range-in-v-for-n-in-10-from-zero
    props: {
        initialColor: {
            type: Object,
            required: true
        },
        itemIndex: {
            type: Number,
            required: true
        },
        renderingKey: {
            type: String,
            required: true
        },
        isSelected: {
            type: Boolean,
            required: true
        }
    },
    mixins: [],
    components: {
        photoshop: Photoshop
    },
    data() {
        return {
            currentColor: {
                'hex': '#FFFFFF'
            },
            colorPickerVisible: false,
            itemIndexValue: -1
        }
    },
    methods: {
        getBackgroundColorStyle() {
            let style = this.isSelected ? 'width: 4rem; height: 2.5rem;' : 'width: 4rem; height: 2rem;'
            style += ' background-color: ' + this.currentColor.hex + ';'
            style += ' border: 1px solid;'
            style += ' border-color: #7f7f7f;'
            return style
        },
        changeToSelected() {
            this.$emit('colorPaletteSelected', { 'color': this.currentColor, 'itemIndex': this.itemIndexValue }) // lets the parent know so other draft components like the drawdown can be redrawn
            this.colorPickerVisible = false
        },
        hideColorPicker() {
            this.$emit('colorPaletteDataChanged', { 'color': this.currentColor, 'itemIndex': this.itemIndexValue }) // lets the parent know so other draft components like the drawdown can be redrawn
            this.colorPickerVisible = false
        },
        doCancel() {
            // this.$emit('colorPaletteDataChanged', { 'color': this.currentColor, 'itemIndex': this.itemIndexValue }) // lets the parent know so other draft components like the drawdown can be redrawn
            this.currentColor = JSON.parse(JSON.stringify(this.initialColor)) // makes deep copy
            this.colorPickerVisible = false
        },
        showColorPicker() {
            this.colorPickerVisible = true
        }
    },

    watch: {
        'renderingKey': function() {
            this.currentColor = this.initialColor
            this.itemIndexValue = this.itemIndex
        }
    },

    computed: {
    },
    created() {
        // console.log('in ColorPalette created, initialColor: ' + JSON.stringify(this.initialColor) + ', itemIndexValue: ' + this.itemIndex)
        this.currentColor = JSON.parse(JSON.stringify(this.initialColor)) // makes deep copy
        this.itemIndexValue = this.itemIndex
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ColorPalette.vue